import React from 'react';
import Image from 'next/image';
import { useBranding } from '../branding/BrandProvider';

interface HeroCompactProps {
  className?: string;
}

export function HeroCompact({ className = '' }: HeroCompactProps) {
  const { branding } = useBranding();

  const hasHeroImage = branding.heroImageUrl;
  const title = branding.heroTitle || 'Upcoming Events';
  const subtitle = branding.heroSubtitle;

  return (
    <section className={`relative overflow-hidden ${className}`}>
      {/* Background */}
      {hasHeroImage ? (
        <div className="relative h-64 md:h-80">
          <Image
            src={branding.heroImageUrl!}
            alt="Hero background"
            width={1920}
            height={640}
            className="w-full h-full object-cover"
            priority
            sizes="100vw"
          />
          {/* Overlay for text readability */}
          <div className="absolute inset-0 bg-black bg-opacity-40" />
        </div>
      ) : (
        <div 
          className="h-64 md:h-80"
          style={{
            background: `linear-gradient(135deg, var(--color-primary), var(--color-secondary))`,
          }}
        />
      )}

      {/* Content */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            {title}
          </h1>
          {subtitle && (
            <p className="text-lg md:text-xl text-white text-opacity-90 max-w-2xl mx-auto">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
